<template>
  <GridContainer class="dcb-teaser-jan-2025">
    <Card
      class="dcb-teaser-jan-2025__card"
      v-bind="card"
    >
    </Card>
  </GridContainer>
</template>

<script setup lang="ts">
import { Badge, Card, GridContainer } from '@i22-td-smarthome/component-library';
import type { CardComponentProps } from '@i22-td-smarthome/component-library/dist/components/card/card.vue';
import type { PictureElementProps } from '@i22-td-smarthome/component-library/dist/elements/picture-element.vue';

const card: CardComponentProps = {
  imagePosition: 'left',
  imageBackground: {
    alt: 'Eine Frau hält ein Smartphone und lehnt an einem großen Smartphone mit einem QR-Code auf dem Bildschirm.',
    lazy: true,
    src: '/content/content-images/dcb/151064b82a2d7c839356aaed3b82988d/keyvisual-aktion-abgelaufen-s@2x.webp',
    srcSm:
      '/content/content-images/dcb/df2fd96cd6aae4c69c5b56287ef36e25/keyvisual-aktion-abgelaufen@2x.webp',
    sizes: 'xs:150vw sm:150vw md:150vw lg:150vw',
  } as PictureElementProps,
  label: {
    text: 'Leider verpasst!',
    customClass: 'text--primary',
  },
  heading: {
    tag: 'h3',
    size: 'md',
    text: 'Aktion beendet',
    spacesBottomRem: true,
  },
  text: 'Leider hast du die Chance auf ein iPhone 16 Pro Max, ein Apple 11" iPad Air oder die Apple AirPods 4 verpasst.<br /><br />Nutze unsere aktuellen Aktionen oder schau bald wieder vorbei um keine neuen Aktionen zu verpassen.',
  badge: {
    bold: true,
    defaultFontSize: 14,
    text: 'Jetzt<br /><span style="font-size: 2em">Apple<br />Produkte</span><br />gewinnen!',
  },
};
</script>

<style scoped lang="scss">
@use 'assets/base' as *;

.dcb-teaser-jan-2025 {
  margin-bottom: $grid-base * 3;
  cursor: default;

  :deep(.card) {
    --card-image-object-position: right center;
    --card-container-justify: center;
    --card-container-content-flex: 0 1 auto;

    --card-badge-top: 52%;
    --card-badge-left: 3%;
    --card-badge-right: none;

    @include mq($mq-sm) {
      --card-badge-top: -9%;
      --card-badge-left: -11%;
    }

    @include mq($mq-md) {
      --card-badge-top: 42%;
      --card-badge-left: 15%;
      --card-image-container-width: 60%;
    }

    .card__image {
      filter: opacity(0.5);
      aspect-ratio: 4 / 3;
    }
  }

  sup,
  :deep(sup) {
    line-height: 0;
  }
}
</style>
